import m from "../../geodata/es2015/puertoRicoLow";
window.am4geodata_puertoRicoLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/puertoRicoLow.js
// module id = null
// module chunks = 